// --------------------- Import Global ---------------------
import axios from "axios";
import Globais, { validateToken } from "../components/Globais";

export const buscarCotaUsuarioByUsuarioIdService = async (
  usuarioId: number,
  cotaUsuarioId: number
) => {
  const Token = validateToken();

  if (Token) {
    const URL = `${Globais.DOMINIOBACK}/cota-usuario/usuario/${usuarioId}/${cotaUsuarioId}`;

    try {
      const response = await axios.get(URL, {
        headers: { Authorization: Token.AuthStr },
      });

      if (response && response.data) {
        return response.data;
      } else {
        return false;
      }
    } catch (error) {
      console.error(error);
    }
  }
};
